import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';
import { Heading } from '../../Heading';

export const StyledHeading = styled(Heading)`
    margin-bottom: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(2), 8)};

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        text-align: center;
    }
`;

export const StyledTickBoxesWrapper = styled('div')`
    /* stylelint-disable unit-allowed-list */
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(1), 0, rem(3)], [4, 0, 12])};

        div {
            & > span:first-of-type {
                height: 100%;
            }
        }

        & > :first-of-type {
            margin-bottom: ${theme.tggSpacing(rem(2), 8)};
        }

        ${theme.breakpoints.up('desktop')} {
            max-width: ${theme.tggSpacing(rem(62.6), 250)};
            margin: ${theme.tggSpacing([0, 'auto', rem(4)], [0, 'auto', 16])};
        }
	`}
`;
